module.exports = __webpack_public_path__ + "static/media/effect_enter_myticket_win.18053f3b.mp3";